export const updateResponsive = value => ({
  type: 'UPDATE_RESPONSIVE',
  payload: value,
});
